import {Component, OnInit, TemplateRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ApiService} from '../../service/api.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

@Component({
  selector: 'app-adesao',
  templateUrl: './adesao.component.html',
  styleUrls: ['./adesao.component.css']
})
export class AdesaoComponent implements OnInit {
  slideOneForm: FormGroup;
  slideOneFormLogin: FormGroup;
  slideOneFormRecuperar: FormGroup;
  modalRef: BsModalRef;
  jsonArrayEstados: any;
  jsonArrayCidades: any;
  jsonArray: any;
  jsonArraySegmento: any;
  jsonValidar: any;
  jsonEmail: any;
  jsonCidadeEstado: any;
  jsonArrayGPS: any;
  latitude: string;
  longetude: string;

  config = {
    keyboard: false,
    backdrop: false,
    ignoreBackdropClick: true
  };

  constructor(private modalService: BsModalService, public formBuilder: FormBuilder, private apiService: ApiService,
              private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.slideOneForm = this.formBuilder.group({
      empresa: ['', Validators.required],
      segmento: ['', Validators.required],
      estado: ['', Validators.required],
      cidade: ['', Validators.required],
      site: ['', Validators.required],
      cnpj: ['', Validators.required],
      endereco: ['', Validators.required],
      numero: ['', Validators.required],
      telefone: ['', Validators.required],
      nota: ['5'],
      responsavel: [''],
      password: ['', Validators.required],
      lat: [''],
      lng: ['']
    });

    this.slideOneFormLogin = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    this.slideOneFormRecuperar = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.carregarEstados();
  }

  carregarEstados() {
    this.apiService.getEstados()
      .subscribe(
        (data: any) => { //start of (1)

          this.jsonArrayEstados = data.data;

          this.carregarCidades();

        }, //end of (1)
        (error: any) => //console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
      );
  }

  carregarCidades() {
    this.apiService.getCidades()
      .subscribe(
        (data: any) => { //start of (1)

          this.jsonArrayCidades = data.data;

          this.carregarSegmento();

        }, //end of (1)
        (error: any) => //console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
      );
  }

  carregarSegmento() {
    this.apiService.getListagem('segmentos')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArraySegmento = data;

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => //console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
      );
  }

  cadastroEmpresa(template: TemplateRef<any>) {
    let config = {
      backdrop: false,
      ignoreBackdropClick: true,
      class: 'gray modal-lg'
    };
    this.modalRef = this.modalService.show(template, config);
  }

  modalEntrar(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  captuarLocalizacao() {
    this.jsonArrayGPS = [];
    this.jsonValidar = [];
    if (this.slideOneForm.invalid) {
      this.toastr.warning('VERIFIQUE OS CAMPOS OBRIGATÓRIOS!', 'Atenção!');
    } else {
      this.spinner.show()
      var params = this.slideOneForm.get('endereco').value + "," + this.slideOneForm.get('numero').value + "," + this.slideOneForm.get('cidade').value;
      this.apiService.getLocalizacao(params)
        .subscribe(
          (data) => { //start of (1)

            this.jsonArrayGPS = data;
            ////console.log(this.jsonArrayGPS.results[0].geometry.location);
            this.latitude = this.jsonArrayGPS.results[0].geometry.location.lat;
            this.longetude = this.jsonArrayGPS.results[0].geometry.location.lng;

            this.slideOneForm.get('lat').setValue(this.latitude);
            this.slideOneForm.get('lng').setValue(this.longetude);

            //console.log(this.latitude);
            //console.log(this.longetude);

            this.salvarDados();

          }, //end of (1)
          (error: any) => {
            this.spinner.hide();
            this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
            //console.log(JSON.parse(JSON.stringify(error)));
          }, //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );
    }
  }

  salvarDados() {
    this.apiService.getListagemId('verificarcadastro', this.slideOneForm.get('site').value)
      .subscribe(
        (data) => { //start of (1)

          this.jsonValidar = data;

          if (this.jsonValidar.length === 0) {
            /*if (this.validarCNPJ()) {
              this.salvarCadastro();
            } else {
              this.spinner.hide();
              this.toastr.warning('CNPJ INFORMADO NÃO É VÁLIDO!', 'Atenção!');
            }*/
            this.salvarCadastro();
          } else {
            this.spinner.hide();
            var nome = "A empresa: " + this.jsonValidar[0].nome + ", já possui cadastro com o e-mail informado!";
            this.toastr.warning(nome, 'Atenção!');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
          //console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  validarCNPJ() {
    var cnpj = this.slideOneForm.get('cnpj').value;

    if (cnpj.length <= 0) {
      return true;
    } else {
      var cnpjvalidar = cnpj.split("-");
      // Esta função retira os caracteres . / - da string do cnpj, deixando apenas os números
      var strCNPJ = cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

      if (cnpjvalidar[1] === "0") {
        strCNPJ = strCNPJ + "0";
      }

      // Verifica se a variável cnpj é igua a "undefined", exibindo uma msg de erro
      if (cnpj === undefined) {
        //console.log('CNPJ INVÁLIDO');
        return false;
        // Testa as sequencias que possuem todos os dígitos iguais e se o cnpj não tem 14 dígitos, retonando falso e exibindo uma msg de erro
      } else if (strCNPJ === '00000000000000' || strCNPJ === '11111111111111' || strCNPJ === '22222222222222' || strCNPJ === '33333333333333' ||
        strCNPJ === '44444444444444' || strCNPJ === '55555555555555' || strCNPJ === '66666666666666' || strCNPJ === '77777777777777' ||
        strCNPJ === '88888888888888' || strCNPJ === '99999999999999' || strCNPJ.length !== 14) {
        //console.log('CNPJ INVÁLIDO 1');
        return false;
      } else if (cnpjvalidar[1] === "00") {
        //console.log('CNPJ VÁLIDO');
        return true;
      } else {
        // A variável numeros pega o bloco com os números sem o DV, a variavel digitos pega apenas os dois ultimos numeros (Digito Verificador).
        var tamanho = strCNPJ.length - 2;
        var numeros = strCNPJ.substring(0, tamanho);
        var digitos = strCNPJ.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;

        // Os quatro blocos seguintes de funções irá reaizar a validação do CNPJ propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
        // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
          //console.log('CNPJ INVÁLIDO 2');
          return false;
        }

        tamanho = tamanho + 1;
        numeros = strCNPJ.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let k = tamanho; k >= 1; k--) {
          soma += numeros.charAt(tamanho - k) * pos--;
          if (pos < 2) {
            pos = 9;
          }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
          //console.log('CNPJ INVÁLIDO 3');
          return false;
        }

        //console.log('CNPJ VÁLIDO');
        return true;
      }
    }
  }

  salvarCadastro() {
    this.apiService.saveCadastro('salvarlojistacheckout', this.slideOneForm.value)
      .subscribe(
        (data) => { //start of (1)

          if (data) {
            this.spinner.hide();
            window.location.href = "https://cvalesegtop.com.br/app/";
          } else {
            localStorage.setItem('acesso', 'false');
            localStorage.setItem('lojistaid', 'null');
            this.spinner.hide();
            this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
          //console.log(JSON.parse(JSON.stringify(error)))
        }, //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  autenticarUser(template) {
    var email = this.slideOneFormLogin.get('email').value;
    var senha = this.slideOneFormLogin.get('password').value;

    if (email === "" || senha === "") {
      this.toastr.warning('Informe seu e-mail e senha!', 'Atenção!');
    } else {
      this.spinner.show();
      this.apiService.autenticarApp('autenticarapp', email, senha)
        .subscribe(
          (data) => { //start of (1)

            this.jsonArray = data;

            if (this.jsonArray.length === 1) {
              //console.log(this.jsonArray[0].statuspagamento);
              if(this.jsonArray[0].datapagamento === "false"){
                this.spinner.hide();
                this.modalRef = this.modalService.show(template, this.config);

                /*this.spinner.hide();
                localStorage.setItem('acesso', 'true');
                localStorage.setItem('lojistaid', this.jsonArray[0].lojistaid);
                this.router.navigate(['/entrar'], { replaceUrl: true });*/
              }else{
                if(parseInt(this.jsonArray[0].statuspagamento) === 1){
                  this.spinner.hide();
                  localStorage.setItem('acesso', 'true');
                  localStorage.setItem('lojistaid', this.jsonArray[0].lojistaid);
                  this.router.navigate(['/entrar'], { replaceUrl: true });
                }else{
                  this.spinner.hide();
                  this.modalRef = this.modalService.show(template, this.config);
                }
              }
            } else {
              this.loginAuditor(email, senha);
            }

          }, //end of (1)
          (error: any) => {
            this.spinner.hide();
            localStorage.setItem('acesso', 'false');
            localStorage.setItem('lojistaid', 'null');
            this.toastr.warning('Usuário ou senha incorretos!', 'Atenção!');
            //console.log("ERROR: " + JSON.parse(JSON.stringify(error)));
          }, //(2) second argument
          () => console.log('all data gets') //(3) second argument
        )
    }
  }

  adesaoPagSeguro(){
    //window.location.href = "https://cartoriotop.com.br/adesao/adesao.php?token="+this.jsonArray[0].lojistaid;
    window.location.href = "https://cartoriotop.com.br/categoria-produto/adesao/";
  }

  loginAuditor(email, senha) {
    this.apiService.autenticarApp('autenticarauditor', email, senha)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;
          this.spinner.hide();
          if (this.jsonArray.length === 1) {
            localStorage.setItem('acesso', 'true');
            localStorage.setItem('lojistaid', 'null');
            this.router.navigate(['/empresas-auditar'], { replaceUrl: true });
          } else {
            localStorage.setItem('acesso', 'true');
            localStorage.setItem('lojistaid', 'null');
            this.toastr.warning('Usuário ou senha incorretos!', 'Atenção!');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          localStorage.setItem('acesso', 'true');
          localStorage.setItem('lojistaid', 'null');
          this.toastr.warning('Usuário ou senha incorretos!', 'Atenção!');
        }, //(2) second argument
        () => console.log('all data gets') //(3) second argument
      )
  }

  recuperarSenha(template) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  recuperar() {
    this.jsonEmail = [];
    if (this.slideOneFormRecuperar.valid) {
      this.spinner.show()
      this.apiService.getListagemId('verificaremail', this.slideOneFormRecuperar.get('email').value)
        .subscribe(
          (data) => { //start of (1)

            this.jsonEmail = data;

            console.log(this.jsonEmail);

            if (this.jsonEmail.length === 0) {
              this.spinner.hide();
              this.toastr.warning('E-mail inválido, informe seu e-mail de cadastro!', 'Atenção!');
            } else {
              this.enviarEmailRecuperacao();
            }

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );
    } else {
      this.toastr.warning('E-mail inválido, informe seu e-mail de cadastro!', 'Atenção!');
    }
  }

  enviarEmailRecuperacao() {
    this.apiService.getEnviarEmail('enviaremailrecuperacao', this.slideOneFormRecuperar.get('email').value, this.jsonEmail[0].lojistaid)
      .subscribe(
        (data) => { //start of (1)

          this.spinner.hide();
          this.toastr.success('Enviamos um e-mail para redefinir sua senha!', 'Sucesso!');
          this.modalRef.hide()

        }, //end of (1)
        (error: any) => //console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
      );
  }

  filtrarCidades(uf) {
    this.jsonCidadeEstado = [];
    for (var i = 0; i < this.jsonArrayCidades.length; i++) {
      if (this.jsonArrayCidades[i].uf === uf) {
        this.jsonCidadeEstado.push({ cidade: this.jsonArrayCidades[i].cidade });
      }
    }
  }
}
